import TrackPlugin from "./TrackPlugin";
import {getExtendData, getGroupTraits, getIdentityTraits} from "../util";
import { getPendoKeyByHost } from "../SdkKeyMappings";


export default class PurePendoTrackPlugin extends TrackPlugin {
	constructor(API_KEY = getPendoKeyByHost()) {
		super('Pendo');
		this.API_KEY = API_KEY
		if(!API_KEY) {
			console.error('Pendo API_KEY is empty')
		}
	}

	get allowInit() {
		return !!this.API_KEY
	}

	async init() {
		if(!this.allowInit) {
			return
		}

		let extedData = getExtendData() || {};


		const pendo = pendoSdk(this.API_KEY)

		const pendoConfig = {
			visitor: {},
			account: {},
		};
		if(extedData.account_id_cipher){
			pendoConfig.visitor = {
				id: extedData.account_id_cipher,
				...getIdentityTraits()
			}
		}

		if(extedData.company_id_cipher){
			pendoConfig.account = {
				id: extedData.company_id_cipher,
				...getGroupTraits()
			}
		}

		pendo.initialize(pendoConfig);

		super.init();
	}

	beforeTrackFilter(trackData) {
		return String(trackData.action).indexOf('c_') !== 0;
	}
	sendTrack(trackData) {

	}
}


// Immediately-invoked function expression to prevent scope pollution...
function pendoSdk (apiKey){ // <-- passed in at the bottom
    /**
     * Bootstrap the `pendo` namespace for deferred execution of common methods
     * until the Agent is fully loaded from the CDN. The deferred methods are:
     * - initialize
     * - identify
     * - updateOptions
     * - pageLoad
     */
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
    v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        // Create a `<script>` tag linked to your application-specific Agent build from our CDN...
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);
    })(window,document,'script','pendo');

	return window.pendo;
}
